export const reportLevelOptions = [
  { value: 1, label: '1'},
  { value: 2, label: '2'},
  { value: 3, label: '3'},
  { value: 4, label: '4'},
];

export const technicalWarrantyDecisionOptions = translations => [
  { value: 'ACCEPTED', label: translations.ACCEPTED },
  { value: 'DENIED', label: translations.DENIED },
];

export const technicalWarrantyRateOptions = translations => [
  { value: 'Agree', label: translations.AGREE },
  { value: 'Disagree', label: translations.DISAGREE },
];

export const commercialWarrantyDecisionOptions = translations => [
  { value: 'CONTRACTUAL_AGREEMENT', label: translations.CONTRACTUAL_AGREEMENT },
  { value: 'GOODWILL_ACCEPTED', label: translations.GOODWILL_ACCEPTED },
  { value: 'CHARGEABLE_TO_CUSTOMER', label: translations.CHARGEABLE_TO_CUSTOMER },
];

export const fieldTypes = {
  STC: 'serviceTechnologyCenters',
  STCPlannerGroup: 'serviceTechnologyCenterPlannerGroup',
  CC: 'customerCenters',
  CCPlantCode: 'customerCenterPlantCode',
  distributors: 'distributors',
  distributorCode: 'distributorCode',
  jobDateFrom: 'jobDateFrom',
  jobDateTo: 'jobDateTo',
};

export const MAX_LENGTH_OF_ADD_JOB_INPUT = 100;
export const MIN_LENGTH_OF_ADD_JOB_SEARCH = 5;



// WEBPACK FOOTER //
// ./src/constants/globalFormValues.js